/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intercept_LogInputs */

const en_intercept_log = /** @type {(inputs: Intercept_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intercept Log`)
};

const id_intercept_log = /** @type {(inputs: Intercept_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log Intersepsi`)
};

/** @type {(inputs: Intercept_LogInputs) => LocalizedString} */
const es_intercept_log = en_intercept_log;

/** @type {(inputs: Intercept_LogInputs) => LocalizedString} */
const fr_intercept_log = en_intercept_log;

/** @type {(inputs: Intercept_LogInputs) => LocalizedString} */
const de_intercept_log = en_intercept_log;

/** @type {(inputs: Intercept_LogInputs) => LocalizedString} */
const ja_intercept_log = en_intercept_log;

/** @type {(inputs: Intercept_LogInputs) => LocalizedString} */
const zh_intercept_log = en_intercept_log;

/** @type {(inputs: Intercept_LogInputs) => LocalizedString} */
const ar_intercept_log = en_intercept_log;

/** @type {(inputs: Intercept_LogInputs) => LocalizedString} */
const it_intercept_log = en_intercept_log;

/** @type {(inputs: Intercept_LogInputs) => LocalizedString} */
const ru_intercept_log = en_intercept_log;

/** @type {(inputs: Intercept_LogInputs) => LocalizedString} */
const pt_intercept_log = en_intercept_log;

/** @type {(inputs: Intercept_LogInputs) => LocalizedString} */
const ko_intercept_log = en_intercept_log;

/**
* | output |
* | --- |
* | "Intercept Log" |
*
* @param {Intercept_LogInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const intercept_log = /** @type {((inputs?: Intercept_LogInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intercept_LogInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intercept_log(inputs)
	if (locale === "es") return es_intercept_log(inputs)
	if (locale === "fr") return fr_intercept_log(inputs)
	if (locale === "de") return de_intercept_log(inputs)
	if (locale === "ja") return ja_intercept_log(inputs)
	if (locale === "zh") return zh_intercept_log(inputs)
	if (locale === "ar") return ar_intercept_log(inputs)
	if (locale === "id") return id_intercept_log(inputs)
	if (locale === "it") return it_intercept_log(inputs)
	if (locale === "ru") return ru_intercept_log(inputs)
	if (locale === "pt") return pt_intercept_log(inputs)
	return ko_intercept_log(inputs)
});